import React from "react";
import PropTypes from "prop-types";

const Logo = ({ width, height }) => {
  return (
    <div>
      <img
        src={`${process.env.PUBLIC_URL}/logo.svg`}
        width={width}
        height={height}
        alt="logo"
        style={{ objectFit: "contain" }}
      />
    </div>
  );
};

Logo.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
};

export default Logo;
